import {
  ticksFormat
} from '../common/datetime';


export class UsercardService {
  constructor($http) {
    this.$http = $http;
    this.loadList(data => {
        this.items = data;
        this.filter_values = Array.from(new Set(data.map(d => d.ad_attributes.office)));
//         console.log(this.filter_values);
    });
//     console.log('Hello from UsercardsService');
  }
  
  loadList(callback) {
    return this.$http.get('/usercard/item_list/')
      .then(({
        data,
        status
      }) => {
        if (callback) callback(data);
      });
  }

  loadItem(full_name, callback) {
    return this.$http.get('/usercard/item/'+full_name)
      .then(({
        data,
        status
      }) => {
        if (callback) callback(data);
      });
  }
  
  loadWebcamShots(full_name, callback) {
    return this.$http.get('/usercard/webcam_shots/'+full_name)
      .then(({
        data,
        status
      }) => {
        if (callback) callback(data);
      });
  }

  saveItem(full_name, value, callback) {
    return this.$http.post('/usercard/item/'+full_name, value)
      .then(({
        data,
        status
      }) => {
        if (callback) callback(data);
      });
  }

  selectItem(full_name) {
      console.log('selectItem ' + full_name);
      this.selectedAttr = undefined;
      this.loadItem(full_name, data => {
        this.selectedItem = data;
//         this.loadWebcamShots(full_name, subdata => this.selectedItem.webcam_shots = subdata);
      });
  }
}




// WEBPACK FOOTER //
// ./src/usercard/usercard.service.js